
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "1024",
    "height": "1024",
    "viewBox": "0 0 1024 1024"
  },
  "children": [
    {
      "tag": "title"
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icomoon-ignore"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M783 0h-542q-66 0-121 32.5t-87.5 87.5-32.5 121v542q0 66 32.5 121t87.5 87.5 121 32.5h542q66 0 121-32.5t87.5-87.5 32.5-121v-542q0-66-32.5-121t-87.5-87.5-121-32.5M512 785q-56 0-109-15-16 3-30 9l-67 42q-30 20-19-15l14-53q2-15-2-31-62-41-97-101-36-61-36-131 0-79 47-148 46-67 124-106 81-40 175-40 86 0 161 34 73 33 121 90l-322 154q-18 10-34.5 10t-32.5-15l-52-46q-35-10-25 23l56 136q10 16 25 18t38-14l374-228q37 62 37 132 0 80-47 149-46 67-124 106-81 40-175 40z"
      }
    }
  ]
})
    }
  